import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../helpers/JsonMapper";
import JsonPixelCollection from "../pixel/JsonPixelCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class StoreTrackingData extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [StoreTrackingData.pixels_attribute_name]: JsonPixelCollection,
      [StoreTrackingData.post_back_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getPixelsAttributeName() {
    return this.pixels_attribute_name;
  }
  static getPostBackAttributeName() {
    return this.post_back_attribute_name;
  }
  getPixels() {
    const pixels = this.getAttribute(StoreTrackingData.getPixelsAttributeName());
    return Array.isArray(pixels) ? pixels : [];
  }
  getPostBackUrl() {
    return this.getAttribute(StoreTrackingData.getPostBackAttributeName());
  }
}
_defineProperty(StoreTrackingData, "pixels_attribute_name", 'pixels');
_defineProperty(StoreTrackingData, "post_back_attribute_name", 'post_back');